module.exports = __webpack_public_path__ + "static/media/bg.2936c6a6.png";